import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: '登录',
        meta: {
            title: '成都睿豹网络科技-面试信息管理系统'
        },
        component: () => import('../views/Login.vue')
    },
    //下面路径映射分了children和菜单的分级无关，只是说明下面的所有路径映射都是再/首页中的，所以写道了childern里
    {
        path: '/Home',
        name: '首页',
        meta: {
            title: '成都睿豹网络科技-面试信息管理系统'
        },
        component: () => import('../views/HomeView.vue'),
        children: [
            {
                path: '/menu/menu',
                name: '菜单管理',
                component: () => import('../views/menu/menu.vue'),
            },
            {
                path: '/usermanage/userinfos',
                name: '账号管理',
                component: () => import('../views/usermanage/userinfos.vue'),
            },
            {
                path: '/role/role',
                name: '角色管理',
                component: () => import('../views/role/role.vue'),
            },
            {
                path: '/configuration/configuration',
                name: '系统配置',
                component: () => import('../views/configuration/configuration.vue'),
            },
            {
                path: '/configuration/unitconfiguration',
                name: '基础配置',
                component: () => import('../views/configuration/unitconfiguration.vue'),
            },
            {
                path: '/configuration/txtconfiguration',
                name: '状态配置',
                component: () => import('../views/configuration/txtconfiguration.vue'),
            },
            {
                path: '/configuration/data',
                name: '面试材料项配置',
                component: () => import('../views/configuration/data.vue'),
            },
            {
                path: '/usermanage/usermanage',
                name: '管理员管理',
                component: () => import('../views/usermanage/usermanage.vue'),
            },
            {
                path: '/unit/unit',
                name: '单位列表',
                component: () => import('../views/role/unit.vue'),
            },
            {
                path: '/joblist/joblist',
                name: '全部职位',
                component: () => import('../views/role/joblist.vue'),
            },
            {
                path: '/jobdetail/jobdetail',
                meta: { isfan: true },
                name: '职位详情',
                component: () => import('../views/role/jobdetail.vue'),
            },
            {
                path: '/joblist/importjobs',
                name: '导入职位信息',
                meta: { isfan: true },
                component: () => import('../views/role/importjobs.vue'),
            },
            {
                path: '/joblist/unimportjobs',
                name: '职位信息导入失败记录',
                meta: { isfan: true },
                component: () => import('../views/role/unimportjobs.vue'),
            },
            // {
            //     path: '/usermanage/consumer',
            //     name: '用户管理',
            //     component: () => import('../views/usermanage/consumer.vue'),
            // },
            {
                path: '/examinee/examinee',
                name: '面试信息管理',
                meta: { keepAlive: true },
                component: () => import('../views/examinee/examinee.vue'),
            },
            {
                path: '/examinee/adminexaminee',
                name: '平台面试信息管理',
                meta: { keepAlive: true },
                component: () => import('../views/examinee/adminexaminee.vue'),
            },
            {
                path: '/examinee/importexaminee',
                name: '导入面试信息',
                meta: { isfan: true },
                component: () => import('../views/examinee/importexaminee.vue'),
            },
            {
                path: '/examinee/unimportexaminee',
                name: '面试信息导入失败记录',
                meta: { isfan: true },
                component: () => import('../views/examinee/unimportexaminee.vue'),
            },
            {
                path: '/students/students',
                name: '全部考生',
                meta: { keepAlive: true },
                component: () => import('../views/students/students.vue'),
            },
            {
                path: '/updates/updatestudent',
                name: '考生信息修改',
                meta: { keepAlive: true },
                component: () => import('../views/updates/updatestudent.vue'),
            },
            {
                path: '/updates/updateallstudent',
                name: '考生信息管理',
                meta: { keepAlive: true },
                component: () => import('../views/updates/updateallstudent.vue'),
            },
            {
                path: '/updates/updatestudentDetail',
                name: '修改考生信息详情',
                meta: { isfan: true },
                component: () => import('../views/updates/updatestudentDetail.vue'),
            },
            {
                path: '/students/importstudent',
                name: '导入考生信息',
                meta: { isfan: true },
                component: () => import('../views/students/importstudent.vue'),
            },
            {
                path: '/students/unimportstudent',
                name: '考生信息导入失败记录',
                meta: { isfan: true },
                component: () => import('../views/students/unimportstudent.vue'),
            },
            {
                path: '/students/auditfirst',
                name: '一审列表',
                meta: { keepAlive: true },
                component: () => import('../views/students/auditfirst.vue'),
            },
            {
                path: '/students/viewstudent',
                meta: { isfan: true },
                name: '考生详情信息',
                component: () => import('../views/students/viewstudent.vue'),
            },
            {
                path: '/students/studentDetail',
                meta: { isfan: true },
                name: '一审考生详情信息',
                component: () => import('../views/students/studentDetail.vue'),
            },
            {
                path: '/students/twostudentDetail',
                meta: { isfan: true },
                name: '二审考生详情信息',
                component: () => import('../views/students/twostudentDetail.vue'),
            },
            {
                path: '/students/auditsecend',
                name: '二审列表',
                meta: { keepAlive: true },
                component: () => import('../views/students/auditsecend.vue'),
            },
            {
                path: '/students/abandonstudent',
                name: '放弃面试考生',
                meta: { keepAlive: true },
                component: () => import('../views/students/abandonstudent.vue'),
            },
            {
                path: '/students/buabandonstudent',
                name: '待重传放弃考生',
                meta: { keepAlive: true },
                component: () => import('../views/students/buabandonstudent.vue'),
            },
            {
                path: '/students/uninfostudent',
                name: '未交资料考生',
                meta: { keepAlive: true },
                component: () => import('../views/students/uninfostudent.vue'),
            },
            {
                path: '/students/buinfostudent',
                name: '待补资料考生',
                meta: { keepAlive: true },
                component: () => import('../views/students/buinfostudent.vue'),
            },
            {
                path: '/students/nopassstudent',
                name: '审核不通过',
                meta: { keepAlive: true },
                component: () => import('../views/students/nopassstudent.vue'),
            },
            {
                path: '/students/passstudent',
                name: '审核通过',
                meta: { keepAlive: true },
                component: () => import('../views/students/passstudent.vue'),
            },
            {
                path: '/logs/managelog',
                name: '后台审查日志',
                component: () => import('../views/logs/managelog.vue'),
            },
            {
                path: '/logs/studentlog',
                name: '考生操作日志',
                component: () => import('../views/logs/studentlog.vue'),
            },
            {
                path: '/logs/updatelog',
                name: '信息修改日志',
                component: () => import('../views/logs/updatelog.vue'),
            },
            {
                path: '/logs/files',
                name: '下载文件管理',
                component: () => import('../views/logs/files.vue'),
            },
            {
                path: '/logs/filestore',
                name: '文件管理',
                component: () => import('../views/logs/filestore.vue'),
            },
            {
                path: '/statistics/jobstatistics',
                name: '职位审核详情',
                meta: { keepAlive: true },
                component: () => import('../views/statistics/jobstatistics.vue'),
            },
            {
                path: '/statistics/jobstatisDetail',
                name: '职位数据详情',
                meta: { isfan: true },
                component: () => import('../views/statistics/jobstatisDetail.vue'),
            },
            {
                path: '/texts/viewlog',
                name: '更新日志管理',
                component: () => import('../views/texts/viewlog.vue'),
            },
            {
                path: '/texts/helpbookemit',
                name: '帮助文档管理',
                component: () => import('../views/texts/helpbookemit.vue'),
            },
            {
                path: '/recycle/examineerecycle',
                name: '面试信息回收站',
                meta: { keepAlive: true },
                component: () => import('../views/recycle/examineerecycle.vue'),
            },
            {
                path: '/recycle/studentrecycle',
                name: '考生信息回收站',
                meta: { keepAlive: true },
                component: () => import('../views/recycle/studentrecycle.vue'),
            },
            {
                path: '/teacher/teacherList',
                name: '考官信息管理',
                component: () => import('../views/teacher/teacherList.vue'),
            },
            {
                path: '/teacher/importteach',
                name: '考官信息导入',
                meta: { isfan: true },
                component: () => import('../views/teacher/importteach.vue'),
            },
            {
                path: '/teacher/teachdetail',
                name: '考官详情',
                meta: { isfan: true },
                component: () => import('../views/teacher/teachdetail.vue'),
            },
            {
                path: '/teacher/shiftList',
                name: '排班信息管理',
                component: () => import('../views/teacher/shiftList.vue'),
            },
            {
                path: '/teacher/importshift',
                name: '排班信息导入',
                meta: { isfan: true },
                component: () => import('../views/teacher/importshift.vue'),
            },
            {
                path: '/avoid/avoidInfo',
                name: '回避信息管理',
                component: () => import('../views/avoid/avoidInfo.vue'),
            },
            {
                path: '/avoid/imporavoidInfo',
                name: '回避信息导入',
                meta: { isfan: true },
                component: () => import('../views/avoid/imporavoidInfo.vue'),
            },
            {
                path: '/avoid/unimporavoidInfo',
                name: '回避信息导入失败记录',
                meta: { isfan: true },
                component: () => import('../views/avoid/unimporavoidInfo.vue'),
            },
            {
                path: '/physical/physicalInfo',
                name: '体检信息管理',
                component: () => import('../views/physical/physicalInfo.vue'),
            },
            {
                path: '/physical/physicalInfoOne',
                name: '确认参加体检',
                component: () => import('../views/physical/physicalInfoOne.vue'),
            },
            {
                path: '/physical/physicalInfoTwo',
                name: '放弃参加体检',
                component: () => import('../views/physical/physicalInfoTwo.vue'),
            },
            {
                path: '/physical/imporphysicalInfo',
                name: '体检信息导入',
                meta: { isfan: true },
                component: () => import('../views/physical/imporphysicalInfo.vue'),
            },
            {
                path: '/physical/unimporphysicalInfo',
                name: '体检信息导入失败记录',
                meta: { isfan: true },
                component: () => import('../views/physical/unimporphysicalInfo.vue'),
            },
            {
                path: '/Investigate/Investigate',
                name: '考察信息管理',
                meta: { keepAlive: true },
                component: () => import('../views/Investigate/Investigate.vue'),
            },
            {
                path: '/Investigate/InvestigateInfo',
                name: '考察资料上传',
                meta: { isfan: true },
                component: () => import('../views/Investigate/InvestigateInfo.vue'),
            },
            {
                path: '/Investigate/Investigatedata',
                name: '考察材料项',
                meta: { isfan: false },
                component: () => import('../views/Investigate/Investigatedata.vue'),
            },
            {
                path: '/Investigate/InvestigateUpdate',
                name: '考察信息修改',
                meta: { isfan: true },
                component: () => import('../views/Investigate/InvestigateUpdate.vue'),
            },
            {
                path: '/Investigate/InvestigateAudit',
                name: '考察信息编辑',
                meta: { keepAlive: true },
                component: () => import('../views/Investigate/InvestigateAudit.vue'),
            },
            {
                path: '/Investigate/InvestigateAuditDetail',
                name: '考察信息复审详情',
                meta: { isfan: true },
                component: () => import('../views/Investigate/InvestigateAuditDetail.vue'),
            },
            {
                path: '/Investigate/InvestigateReturn',
                name: '考察信息回收站',
                meta: { keepAlive: true },
                component: () => import('../views/Investigate/InvestigateReturn.vue'),
            },
            {
                path: '/Investigate/InvestigateUser',
                name: '考察人员关联',
                meta: { keepAlive: true },
                component: () => import('../views/Investigate/InvestigateUser.vue'),
            },  
            {
                path: '/Investigate/InvestigateView',
                name: '考察信息详情',
                meta: { isfan: true },
                component: () => import('../views/Investigate/InvestigateView.vue'),
            },
            {
                path: '/Investigate/InvestigateSure',
                name: '考察信息复审',
                meta: { keepAlive: true },
                component: () => import('../views/Investigate/InvestigateSure.vue'),
            },
        ]
    },
    {
        path: '/texts/helpbook',
        meta: {
            title: '面试帮助文档'
        },
        name: '帮助文档管理',
        component: () => import('../views/texts/helpbook.vue'),
    },
    {
        path: '/teacher/teachlogin',
        meta: {
            title: '考官信息管理'
        },
        name: '考官信息管理',
        component: () => import('../views/teacher/teachlogin.vue'),
    },
    {
        path: '/teacher/signTeacher',
        meta: {
            title: '考官签到'
        },
        name: '考官签到',
        component: () => import('../views/teacher/signTeacher.vue'),
    },
    {
        path: '/teacher/teacherInfo',
        name: '考官信息',
        meta: {
            title: '考官信息'
        },
        name: '考官信息',
        component: () => import('../views/teacher/teacherInfo.vue'),
    },
    {
        path: '/teacher/updateTeacher',
        name: '考官信息完善',
        meta: {
            title: '考官信息完善'
        },
        name: '考官信息完善',
        component: () => import('../views/teacher/updateTeacher.vue'),
    },
    // {
    //     path: '/texts/text',
    //     meta: {
    //         title: '测试页面'
    //     },
    //     name: '测试页面',
    //     component: () => import('../views/texts/text.vue'),
    // },

]

const router = new VueRouter({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
